/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Canvas.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
class Canvas extends Component {
  state = {
    fullScreen: false,
  };
  canvasRef = React.createRef();
  wrapperRef = React.createRef();
  // after component is rendered
  componentDidMount = () => {
    this.canvas = this.canvasRef.current;
    this.ctx = this.canvas.getContext('2d');

    // this.size.width = canvas.offsetWidth;
    // this.size.height = canvas.offsetHeight;

    // to keep the ratio as defined by size in data
    this.canvas.width = this.canvas.clientWidth;
    this.canvas.height = this.canvas.clientHeight;

    this.canvas.style.background = 'white';

    // this.ctx.fillStyle = 'rgba(0, 161, 180, 1)';
  };

  componentDidUpdate = () => {
    // tick
    const ctx = this.ctx;
    const canvas = this.canvas;

    if (this.state.fullScreen !== this.props.fullScreen) {
      this.setState(state => ({ fullScreen: !state.fullScreen }));
      canvas.width = this.props.size.width;
      canvas.height = this.props.size.height;
    }

    const { data, wallWidth, wallY } = this.props;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = 0, l = data.length; i < l; i++) {
      const d = data[i];
      ctx.fillStyle = d.color;
      ctx.beginPath();
      ctx.arc(...d.pos, d.radius, 0, 2 * Math.PI);
      ctx.fill();
    }

    ctx.save();
    ctx.lineWidth = wallWidth;

    this.ctx.strokeStyle = 'rgb(202,241,240)';
    ctx.beginPath();

    ctx.moveTo(canvas.width / 2, wallY);
    ctx.lineTo(canvas.width / 2, canvas.height);
    ctx.stroke();

    ctx.restore();
  };

  render() {
    return (
      <div ref={this.wrapperRef} className={styles.wrapper}>
        {/* <div className={styles.heading}>{this.props.title}</div> */}

        <canvas ref={this.canvasRef} className={styles.canvas} />
      </div>
    );
  }
}

export default Canvas;
